import { render, staticRenderFns } from "./CreateFormV2.vue?vue&type=template&id=10eef3f6"
import script from "./CreateFormV2.vue?vue&type=script&lang=js"
export * from "./CreateFormV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports